import React, { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import PageTitle from '../../../../components/partials/PageTitle'
import { getRenewedPolicy } from '../../../../redux/slice/report/reportSlice';
import ReportFilter from './ReportFilter';
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import moment from 'moment';

const RenewedPolicy = () => {
    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false);

    const { user } = useSelector((state) => state.auth);
    const { customerOverviewData } = useSelector((state) => state.report);

    const dispatch = useDispatch();

    const CCPdfRef = useRef();

    const breadcrumb = {
        from: {
          title: "Policy Report",
          link: "/admin/reports/policy-report",
        },
        current: {
          title: "Renewed Policy",
          link: null,
        },
      };

      const processedData = customerOverviewData?.map((row) => {
        const fullName = `${row.customerFirstName} ${row.customerLastName}`;
        const agent = `${row.agentFirstName} ${row.agentLastName}`;
        const date = `${moment(row?.renewalDate).format('YYYY-MM-DD')}`
    
        return { ...row, full_name: fullName, agent, date }; // Modify status property while keeping the rest
      });
    
      const headers = [
        { label: "Policy Number", key: "policyAppNumber" },
        { label: "Customer Name", key: "full_name" },
        { label: "Policy", key: "policyName" },
        { label: "Coverage", key: "coverage" },
        { label: "Renewal Date", key: "date" },
        { label: "Premium Amount", key: "premiumAmount" },
        { label: "Agent", key: "agent" },
        { label: "Office", key: "officeName" },
      ];
    
      // print table to pdf
      const generatePDF = useReactToPrint({
        content: () => CCPdfRef.current,
        documentTitle: "Customer Policy Information",
      });

      useEffect(() => {
        if (filteredItem) {
          if (filterData.office_id === "") {
            const updatedFilterData = {
              ...filterData,
              office_id: user?.user?.office_id,
            };
            dispatch(getRenewedPolicy(updatedFilterData));
          } else {
            dispatch(getRenewedPolicy(filterData));
          }
        }
      }, [dispatch, filterData, filteredItem, user?.user?.office_id]);
  return (
    <>
        {/* page title */}
        <PageTitle title='Renewed Policy Renewal' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
            <ReportFilter
                page={"renewedPolicy"}
                setFilterData={setFilterData}
                setFilteredItem={setFilteredItem}
                filteredItem={filteredItem}
            />
            {customerOverviewData && (
          <div className='row mb-3'>
            <>
              <div className='d-flex justify-content-end align-items-center'>
                <div className=' d-flex align-items-center border '>
                  <span
                    className='bg-info me-2 text-white'
                    style={{ padding: "3px" }}
                  >
                    Export to
                  </span>

                  <span
                    href='#'
                    id='btnExport'
                    className='me-1 cursor-p'
                    title='Export to Pdf'
                    onClick={generatePDF}
                  >
                    <img
                      src={pdf}
                      alt='export-pdf'
                      style={{ height: "25px" }}
                    />
                  </span>
                  {customerOverviewData ? (
                    <CSVLink
                      data={processedData}
                      headers={headers}
                      style={{ fontWeight: "bolder", cursor: "pointer" }}
                      filename='Customer Policy Information'
                    >
                      <span
                        href='#'
                        id='btnExport'
                        className='mr-1'
                        title='Export to Excel'
                      >
                        <img
                          src={excel}
                          alt='export-excel'
                          style={{ height: "25px", marginRight: "5px" }}
                        />
                      </span>
                    </CSVLink>
                  ) : null}
                </div>
              </div>
              <div className='table-responsive'>
                <table
                  className='table table-centered table-striped nowrap w-100 no-footer'
                  ref={CCPdfRef}
                >
                  <thead>
                    <tr>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "100.8px" }}
                            aria-label='Email: activate to sort column ascending'
                        >
                            Policy No.
                        </th>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "100.8px" }}
                            aria-label='Email: activate to sort column ascending'
                        >
                            Customer Name
                        </th>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "100.8px" }}
                            aria-label='Email: activate to sort column ascending'
                        >
                            Policy
                        </th>      
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "120.8px" }}
                            aria-label='Status: activate to sort column ascending'
                        >
                            Coverage
                        </th>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "120.8px" }}
                            aria-label='Status: activate to sort column ascending'
                        >
                            Renewal Date
                        </th>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "120.8px" }}
                            aria-label='Status: activate to sort column ascending'
                        >
                            Premium Amount
                        </th>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "120.8px" }}
                            aria-label='Status: activate to sort column ascending'
                        >
                            Agent
                        </th>
                        <th
                            className='sorting'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "120.8px" }}
                            aria-label='Status: activate to sort column ascending'
                        >
                            Office
                        </th>
                    </tr>
                  </thead>
                  {customerOverviewData?.length ? (
                    <tbody>
                      {customerOverviewData?.map((item, i) => (
                        <tr key={i}>
                            <td className='text-dark'>
                                {item?.policyAppNumber}
                            </td>
                            <td>
                                {item?.customerFirstName + " "}
                                {item?.customerLastName}
                            </td>
                          <td className='text-dark'>
                            {item?.policyName}
                          </td>
                          <td className='table-user'>{item?.coverage}</td>
                          <td>{moment(item?.renewalDate).format('YYYY-MM-DD')}</td>
                          <td>{item?.premiumAmount}</td>
                          <td>
                            {item?.agentFirstName + " "}
                            {item?.agentLastName}
                          </td>
                          <td>{item?.officeName}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </table>
                {customerOverviewData?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
              </div>
            </>
          </div>
        )}
        </div>
    </>
  )
}

export default RenewedPolicy